<template>
    <div if="text" class="copyable-text">
        <span class="text">{{ text }}</span>
        <i ref="copyButton" class="copy-btn fa-light fa-copy"></i>
        <input type="hidden" :id="containerId" :value="text" />

        <span class="icon-container">
            <i class="fas fa-check" :class="{ shown: isCopiedIconVisible }" />
        </span>
    </div>
</template>

<script setup lang="ts">
    import ClipboardJS from "clipboard";
    import { v4 as uuidv4 } from "uuid";
    import { onMounted, ref } from "vue";

    const containerId = ref("id-" + uuidv4());

    defineProps<{
        text?: string;
    }>();

    const iconsTimeout = 800;
    const isCopiedIconVisible = ref(false);
    const copyButton = ref<HTMLElement | null>(null);

    onMounted(() => {
        if (copyButton.value == null) return;

        const clipboard = new ClipboardJS(copyButton.value!, {
            target: function () {
                return document.querySelector("#" + containerId.value) as HTMLElement;
            },
        });

        clipboard.on("success", () => {
            isCopiedIconVisible.value = true;
            window.setTimeout(() => {
                isCopiedIconVisible.value = false;
            }, iconsTimeout);
        });
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    .copyable-text {
        white-space: nowrap;
        padding-right: 10px;

        .copy-btn {
            position: relative;
            cursor: pointer;
            margin-left: 0.2em;
            color: white;
            font-size: 1.25em;
            opacity: 0.8;
            transition: opacity 0.3s variables.$easeOutExpo;
            padding: 2px;

            &:hover {
                opacity: 1;
            }

            &:after {
                content: "";
                position: absolute;
                top: -4px;
                right: -4px;
                bottom: -4px;
                left: -4px;
            }
        }

        .icon-container {
            position: relative;
            display: inline-block;

            > i {
                position: absolute;
                color: colors.$green;
                margin-left: 0.2em;
                transition: opacity 0.1s variables.$easeOutExpo;
                opacity: 0;
                bottom: -2px;

                &.shown {
                    opacity: 1;
                }
            }
        }
    }
</style>
